export default defineNuxtRouteMiddleware(async () => {
  const { status } = useAuth();

  if (status.value === 'unauthenticated') {
    return;
  }

  return await navigateTo('/');
});
